module.exports = __webpack_public_path__ + "img/rover.85dadaac.png";